module.exports = __webpack_public_path__ + "static/img/today_best_team.ae63d5b7.png";